import { render, staticRenderFns } from "./MpFindWords.vue?vue&type=template&id=15d8b062&scoped=true&"
import script from "./MpFindWords.vue?vue&type=script&lang=js&"
export * from "./MpFindWords.vue?vue&type=script&lang=js&"
import style0 from "./MpFindWords.vue?vue&type=style&index=0&id=15d8b062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d8b062",
  null
  
)

export default component.exports